<script>
  import { run } from 'svelte/legacy';

  import { onDestroy } from "svelte";
  /**
   * @typedef {Object} Props
   * @property {any} [id]
   * @property {string} [name]
   * @property {any} [value]
   */

  /** @type {Props} */
  let { id = void 0, name = "", value = $bindable(void 0) } = $props();
  let paste = $state(false);
  let errorClass = $state("");
  let timer = $state(void 0);
  const remove_whitespace = (str) => str.replace(/\s+/g, "");
  const test_input = (str) =>
    !isNaN(str) && str.length === 10 && str[0] === "9";
  run(() => {
    if (value) {
      clearTimeout(timer);
      let processed_value = remove_whitespace(value);
      if (test_input(processed_value)) {
        errorClass = "";
        value = processed_value;
      } else if (paste) {
        errorClass = " input-validation-error";
        paste = false;
        value = processed_value;
      } else {
        timer = setTimeout(() => {
          errorClass = " input-validation-error";
        }, 1500);
      }
    }
  });
  let handlepaste = () => {
    paste = true;
  };
  onDestroy(() => {
    clearTimeout(timer);
    timer = void 0;
  });
</script>

<input
  class={`input-primary${errorClass}`}
  bind:value
  onpaste={handlepaste}
  {name}
  id={id ? id : name}
  type="text"
  placeholder="e.g. 90 00000 00 0"
  aria-label="Account number e.g. 90 00000 00 0"
/>
